import script from "./FilemanagerElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilemanagerElement.vue?vue&type=script&lang=ts&setup=true"

import "./FilemanagerElement.vue?vue&type=style&index=0&id=e1e2dff8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1e2dff8"]])

export default __exports__